module.exports = "<div id=\"line-Area-Uno\" style=\"height: 400px; min-width: 310px\"></div>"